{
  "home": {
    "listen": "écouter de la bonne musique"
  }
}